module.exports = __webpack_public_path__ + "static/media/grin-tongue-squint.0353173c.svg";